
const LoadingComponent = () => {
  return (
    <div className='spinner-container'>
        <div></div>
    </div>
  )
}

export default LoadingComponent  